
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"73","height":"56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M60.5 48v2a6 6 0 01-6 6h-48a6 6 0 01-6-6V18a6 6 0 016-6h2v6H7.25a.75.75 0 00-.75.75v30.5a.75.75 0 00.75.75h46.5a.75.75 0 00.75-.75V48h6zm5.25-42h-46.5a.75.75 0 00-.75.75v30.5a.75.75 0 00.75.75h46.5a.75.75 0 00.75-.75V6.75a.75.75 0 00-.75-.75zm.75-6a6 6 0 016 6v32a6 6 0 01-6 6h-48a6 6 0 01-6-6V6a6 6 0 016-6h48zm-33 14a5 5 0 11-10 0 5 5 0 0110 0zm-9 12l4.94-4.94a1.5 1.5 0 012.12 0L36.5 26l12.94-12.94a1.5 1.5 0 012.12 0L60.5 22v10h-36v-6z","fill":"#282E3E"}})])
          )
        }
      }
    